export const POST_MESSAGE_KEY = {
    TEMPLATE_NOT_INSTALLED: 'templateNotInstalled', // 模板中心提交数据
    /** 插件oauth授权回调 */
    PLUGIN_OAUTH_CALLBACK: 'pluginOauthCallback',
    /** 插件安装 */
    PLUGIN_INSTALL_AGENT: 'pluginInstallAgent'
};
